import * as React from 'react';
import { createPortal } from 'react-dom';
import { UIHeading4 } from '@cian/ui-kit';

import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './FullscreenHeader.css';

export interface IFullscreenHeaderProps {
  name: string;
  phoneButton: React.ReactNode;
  callbackButton: React.ReactNode;
  onClose(): void;
}

export function FullscreenHeader({ name, phoneButton, onClose, callbackButton }: IFullscreenHeaderProps) {
  return createPortal(
    <div data-name="FullscreenHeader" className={styles['controls']}>
      <div className={styles['title']}>
        <UIHeading4 color="text-on-bright-default">{name}</UIHeading4>
      </div>
      <div className={styles['actions']}>
        {phoneButton}
        {callbackButton}
      </div>
      <button className={styles['close']} data-name="CloseButton" onClick={onClose}>
        <IconActionClose16 color="icon-on-bright-default" display="block" />
      </button>
    </div>,
    document.body,
  );
}
